<ion-header>
    <ion-toolbar>
        <ion-title>{{ 'Invite User' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button color="dark" fill="clear" (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content #content>

    @if (formActive) {
        <form [formGroup]="form">

            <ion-list>
                <!-- Name -->
                @if (contacts?.length) {
                    <ion-item>
                        <ion-input label="User's Name" labelPlacement="floating" autocapitalize="true" formControlName="name" name="name"></ion-input>
                    </ion-item>
                }

                <!-- Phone -->
                <ion-row>
                    <ion-col size="4">
                        <ion-item (click)="getCountryCode()">
                            <ion-input readonly type="tel" [value]="form.get('country_code').value" name="Country code" label="{{ 'Country' | translate }}" labelPlacement="stacked"></ion-input>
                            <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                        </ion-item>
                    </ion-col>
                    <ion-col size="8">
                        <ion-item>
                            <ion-input labelPlacement="floating" type="tel" formControlName="phone" name="Phone">
                                <div slot="label">{{'Area code + Phone' | translate}} <ion-text color="danger">*</ion-text></div>
                            </ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="12" class="ion-text-center">
                        <ion-text color="medium">{{'OR' | translate}}</ion-text>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <ion-item>
                            <ion-input labelPlacement="floating" type="email" formControlName="email" name="Email" appEmailLowercase>
                                <div slot="label">{{'Email' | translate}}<ion-text color="danger">*</ion-text></div>
                            </ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>

            </ion-list>

            <ion-button color="secondary" class="ion-margin" (click)="submit()" expand="full">
                {{'Save' | translate}}
            </ion-button>
        </form>
    }

    <ng-container *ngIf="authUser?.trackers?.length && !users?.length && !form?.get('name')?.value?.length">
    <ion-list>
        <ion-list-header>
            <ion-label>{{'Recently used trackers' | translate}}</ion-label>
        </ion-list-header>

        <ion-item button *ngFor="let user of authUser.trackers" (click)="applyContactInfo(user)">
            <ion-avatar slot="start">
                <img *ngIf="user.profile_image; else defaultAvatar" [src]="user.profile_image" alt="Profile Image" />
            </ion-avatar>
            <ng-template #defaultAvatar>
                <ion-avatar>
                    <ion-icon name="person-circle-outline" size="large"></ion-icon>
                </ion-avatar>
            </ng-template>
            <ion-label>
                {{ user.first_name }} {{ user.last_name }}
                <p>{{ user?.phone || user?.email }} </p>
            </ion-label>
        </ion-item>
    </ion-list>
</ng-container>


    @if (contacts?.length && form?.get('name').dirty) {
        <ion-list>
            <ion-list-header>
                <ion-label>{{'Select Contacts' | translate}}</ion-label>
            </ion-list-header>
            @if (!users?.length) {
                <ion-item lines="none">
                    <ion-label>{{'Start typing user's name...' | translate}}</ion-label>
                </ion-item>
            }

            @for (user of users; track $index) {
                <ion-item (click)="applyContactInfo(user)">
                    <ion-label>
                        {{ user.name }}
                        <p>{{user.phone}}</p>
                    </ion-label>
                </ion-item>
            }
        </ion-list>
    }

</ion-content>